export const COMPETITIONS_QUERY_KEY = 'competitions';
export const COMPETITION_ORGANISERS_QUERY_KEY = 'competition-organisers';
export const IMPORT_QUERY_KEY = 'event-import';
export const PARTICIPANTS_QUERY_KEY = 'participants';






